module.exports = __webpack_public_path__ + "static/media/Developmenticon01.ae9d3314.png";